/**
 * Apigee API keys for platforms and environments
 */
const APIGEE_API_KEY_MAP = {
    android: {
        dev: "gQMYpa0bNsDAY9W3o5KGKmJYDo7IfYWT",
        qa1: "u4y9geXydLn6dQXZBCbetGRgvG3eNWto",
        qa2: "u4y9geXydLn6dQXZBCbetGRgvG3eNWto",
        qa3: "u4y9geXydLn6dQXZBCbetGRgvG3eNWto",
        psp: "ZiFSBsrZFkPiSQwS4B95UIpBSn2BgocO",
        prod: "ZiFSBsrZFkPiSQwS4B95UIpBSn2BgocO",
    },
    ios: {
        dev: "j380jBmnvdSANW9GQUpnh8BlAGnV5kPG",
        qa1: "j6llYCeGIWlom3JZLaCUT8mxvgZuZGA1",
        qa2: "j6llYCeGIWlom3JZLaCUT8mxvgZuZGA1",
        qa3: "j6llYCeGIWlom3JZLaCUT8mxvgZuZGA1",
        psp: "NQFqviN0sWSvm3Nuiq73SlOsQd2drGmc",
        prod: "NQFqviN0sWSvm3Nuiq73SlOsQd2drGmc",
    },
    web: {
        dev: "wU5VdAI4fv7jgsaAOJDREixc3MOaUs1R",
        qa1: "BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs",
        qa2: "BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs",
        qa3: "BdWWhZRHCmdNq74CJYfaozM2gZCZqEDs",
        psp: "XhnbsDYmBensf2vqVXAfv0uD7SJBA27u",
        prod: "XhnbsDYmBensf2vqVXAfv0uD7SJBA27u",
    },
};
const ORIGIN_MAP = {
    dev: "https://secure-dev.ally.com",
    qa1: "https://secure-qa1.ally.com",
    qa2: "https://secure-qa2.ally.com",
    qa3: "https://secure-qa3.ally.com",
    psp: "https://secure-prodsupt.ally.com",
    prod: "https://secure.ally.com",
};
/**
 * Gets the environment config from an environment parameter
 * @param environment Environment argument
 * @returns Returns environment config type
 */
export function getEnvironmentConfig(environment) {
    var _a;
    const platform = typeof environment !== "string"
        ? environment.platform
        : environment.split("-")[0];
    const name = typeof environment !== "string"
        ? environment.name
        : environment.split("-")[1];
    const apigeeApiKey = APIGEE_API_KEY_MAP[platform][name];
    const origin = ORIGIN_MAP[name];
    const fetchOrigin = (platform === "web" && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin)) || origin;
    return {
        apigeeApiKey,
        fetchOrigin,
        name,
        origin,
        platform,
    };
}
//# sourceMappingURL=environment.js.map